export type DeleteUserData = {
  userName: string;
  personId: number;
};

export function DefaultDeleteUserData() {
  return {
    userName: "",
    personId: 0,
  };
}

export interface Accommodations {
  wheelChairTravel: boolean;
  wheelChairPresent: boolean;
  wcToVehicleTransfer: boolean;
  personAttributesKeyId: number;
}

export function DefaultAccommodations() {
  return {
    wheelChairTravel: false,
    wheelChairPresent: true,
    wcToVehicleTransfer: true,
    personAttributesKeyId: 0,
  };
}

export type UserEmailAddressStatusResponse = {
  subjectId: string;
  isLocked: boolean;
  status: boolean;
  disabledReasonId: number;
  disabledReason: string;
};

export type UpdateEmailAddressRequest = {
  subjectId: string;
  email: string;
  username: string;
};

export type UpdateEmailAddressResponse = {
  value: Record<string, string>;
  errors: string[];
  succeeded: boolean;
};

export type TrustedContact = {
  personId: number;
  firstName: string;
  lastName: string;
  email: string;
  emailAttributes: {
    noEmailAddress: boolean;
    notificationOn: boolean;
    communicationTypes: {
      informative: boolean;
      promotional: boolean;
    };
  };
  phone: string;
  phoneAttributes: {
    canReceiveVoiceCalls: boolean;
    canReceiveTexts: boolean;
    noPhoneNumber: boolean;
    notificationOn: boolean;
    communicationTypes: {
      informative: boolean;
      promotional: boolean;
    };
  };
  relationship: number;
  priority: number;
  relationshipName: string;
  personAttributesKeyId: number;
  isActive: boolean;
};

export type TC_InitialValues = {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  relationship: number | undefined;
  personAttributesKeyId: number;
};

export const defaultTC_InitialValues = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  relationship: undefined,
  personAttributesKeyId: 0,
};
